import React, { Component } from "react";
import styled from "styled-components";
import { colors } from "theme";

const RoundedButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "12px")};
  padding: ${(props) => (props.padding ? props.padding : "1.8rem 0")};
  opacity: ${(props) => (props.opacity ? props.opacity : "1")};
  border: ${(props) =>
    props.borderColor ? `1px solid ${props.borderColor}` : "none"};
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : "10px"};
  background-color: ${(props) =>
    props.bgColor ? props.bgColor : colors.primaryColor};
  /* background-color: ${(props) =>
    props.bgColor ? props.bgColor : "#4154da"}; */

  font-family: "Montserrat";
  font-size: ${(props) => (props.fontSize ? props.fontSize : "18px")};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : "500")};
  text-align: center;
  color: ${(props) => (props.textColor ? props.textColor : "#ffffff")};
  text-transform: ${(props) =>
    props.textTransform ? props.textTransform : "none"};
  letter-spacing: ${(props) =>
    props.letterSpacing ? props.letterSpacing : "0px"};
  cursor: pointer;
  transition: 0.2s ease-in-out all;

  &:hover {
    background-color: ${(props) =>
      props.hoverBgColor ? props.hoverBgColor : "#231a3ddd"};
    transform: translateY(1px);
  }

  &:focus {
    outline: none;
  }

  & svg {
    margin-right: 1rem;
  }
`;

export default class LargeButton extends Component {
  render() {
    const { disabled, loader = true, label, ...rest } = this.props;
    return (
      <RoundedButton disabled={disabled} {...rest}>
        <span className={rest.customLabelCss ? rest.customLabelCss : ""}>
          {label}
        </span>
      </RoundedButton>
    );
  }
}
